/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";

import { ThemeProvider } from "@mui/material";
import BaseGraph from "./BaseGraph";
import { useNitroStore } from "../../../../../store/Store";

import {
  formatByCalendarType,
  getAdjustedYears,
} from "../../../../../utils/Dates";

import { useIsComponentMounted } from "../../../../../hooks/useIsComponentMounted";
import NitroService from "../../../../../utils/nitro.service";
import { table2Theme } from "../Table2";
// import { useNotificationStore } from "../../../../../store/notificationStore";
// import { toSentenceCase } from "../../../../../utils/casing";

const uomFactor = 1;

const ModeOfTransportGraph = () => {
  const [product] = useNitroStore((state) => [state.product]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [loading, setLoading] = useState(true);

  const [data, setData] = useState([] as any[]);
  const [rows, setRows] = useState([] as any[]);

  const startYear = new Date().getFullYear() - 4;
  const endYear = new Date().getFullYear();
  const [years, setYears] = useState(getAdjustedYears(endYear, "cal"));
  useEffect(() => {
    setYears(getAdjustedYears(endYear, "cal"));
  }, [endYear]);

  useEffect(() => {
    const newRows = formatByCalendarType(data, {
      calendarFormat: "cal",
      startYear,
      endYear,
      property: "mode",
    });

    setRows(newRows);
  }, [data, startYear, endYear]);

  const isComponentMounted = useIsComponentMounted();
  useEffect(() => {
    if (!isComponentMounted) return;

    const load = async () => {
      // if (!customerName && (!cityNames || cityNames.length === 0)) {
      //   setRows([]);
      //   return;
      // }

      try {
        setLoading(true);
        // const result = await NitroService.proxy(
        //   "ModeOfTransport",
        //   {
        //     customerName: encodeURIComponent("GROWMARK INC"),
        //     productType: product,
        //     // industry,
        //     // marketer,
        //     // cityNames,
        //     // stateNames,
        //     startYear,
        //     endYear,
        //   },
        //   1,
        //   1000
        // );

        // setData(result);
      } catch (err) {
        console.error(err);
      }

      setLoading(false);
    };

    load();
  }, [isComponentMounted, product, startYear, endYear]);

  const infoMessage = (
    <>Filter criteria: Customer Name, Product Type, Industry, Cities, States</>
  );

  const body = (
    <ThemeProvider theme={table2Theme}>
      <TableContainer
        component={Paper}
        style={{ maxHeight: 190 }}
        sx={{ boxShadow: "none" }}
      >
        <Table stickyHeader size="small" aria-label="a dense table">
          <TableHead>
            <TableRow className="Header">
              <TableCell>Mode</TableCell>
              <TableCell>{years[0]}</TableCell>
              <TableCell>{years[1]}</TableCell>
              <TableCell>{years[2]}</TableCell>
              <TableCell>{years[3]}</TableCell>
              <TableCell>{years[4]}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody style={{ overflowY: "scroll" }}>
            {rows &&
              rows.length > 0 &&
              rows.map((row) => (
                <TableRow
                  key={row.mode}
                  style={{
                    cursor: "pointer",
                  }}
                >
                  <TableCell>{row.mode}</TableCell>

                  <TableCell>
                    {Math.round(row.year1 * uomFactor).toLocaleString("en", {
                      useGrouping: true,
                    })}
                  </TableCell>
                  <TableCell>
                    {Math.round(row.year2 * uomFactor).toLocaleString("en", {
                      useGrouping: true,
                    })}
                  </TableCell>
                  <TableCell>
                    {Math.round(row.year3 * uomFactor).toLocaleString("en", {
                      useGrouping: true,
                    })}
                  </TableCell>
                  <TableCell>
                    {Math.round(row.year4 * uomFactor).toLocaleString("en", {
                      useGrouping: true,
                    })}
                  </TableCell>
                  <TableCell>
                    {Math.round(row.year5 * uomFactor).toLocaleString("en", {
                      useGrouping: true,
                    })}
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </ThemeProvider>
  );
  return (
    <BaseGraph
      // loading={loading}
      loading={false}
      title="MODE OF TRANSPORT"
      infoMessage={infoMessage}
      height={200}
    >
      {body}
    </BaseGraph>
  );
};

export default ModeOfTransportGraph;
